// @flow
import * as Sentry from '@sentry/browser';

import config from 'chronos-config';


export function throwError(err) {
  if (config.useSentry) {
    const error = (
      err.constructError
        ? (
          new Error(`${err?.additionalData?.responseStatus} ${err?.additionalData?.url}`)
        ) : err
    );
    Sentry.withScope((scope) => {
      if (err.additionalData) {
        Object.keys(err.additionalData).forEach((key) => {
          scope.setExtra(key, err.additionalData[key]);
        });
      }
      Sentry.captureException(error);
    });
  }
  console.error(err);
  /*
  yield eff.call(console.error, err);
  yield eff.fork(notify, {
    title: (
      err?.json?.errorMessages[0]
      || err
    ),
  });
  */
}
